import {useSigma} from "@react-sigma/core";
import {useFileDataset} from "../../hooks/useJsonLoader";
import {useEffect} from "react";
import {useEntrezMap} from "../../hooks/useEntrezMap";

const GraphDataController = () => {
  const sigma = useSigma();
  const graph = sigma.getGraph();

  const dataset = useFileDataset();
  const entrezMap = useEntrezMap();

  useEffect(() => {
    if (!graph || !dataset || !entrezMap) return;

    graph.clear();

    dataset.nodes.forEach((node) => {
      if (node.x !== undefined && node.y !== undefined) {
        const other_label = entrezMap[node.e].s;
        let label = node.n;
        if (label !== other_label) {
          label = label + " / " + other_label
        }
        graph.addNode(node.i, {
          ...node,
          label,
          size: 2,
        });
      }
    });

    dataset.edges.forEach((edge) =>
      graph.addEdge(edge.s, edge.t, {size: 1, weight: edge.w}),
    );

    console.log(`Loaded ${graph.nodes().length} nodes and ${graph.edges().length} edges.`);
  }, [graph, dataset, entrezMap]);

  return null;
};

export default GraphDataController;
